import { useGetCardSetConfig } from '@sorare/core/src/set';

export const useSetHasMultipleSkins = (setSlug: Nullable<string>) => {
  const getCardSetConfig = useGetCardSetConfig();
  const setConfig = getCardSetConfig(setSlug);
  return setConfig.skins.length >= 2;
};
